import React, { useState, useEffect, useMemo } from 'react';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import { prospoTheme } from '../theme/theme';

export const DynamicThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // 1. Use our custom prospo theme as the base (not MUI default)
  const defaultTheme = prospoTheme;
  useTheme(); // keep hook call to satisfy rules-of-hooks
  const [sideCarWidth, setSideCarWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      // Read the variable set by FloatingChat
      const widthStr = getComputedStyle(document.body).getPropertyValue('--prospo-sidecar-width');
      const width = widthStr ? parseInt(widthStr, 10) : 0;
      setSideCarWidth(width);
    };

    // Listen for the custom resize event
    window.addEventListener('resize', handleResize);
    handleResize(); 

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const dynamicTheme = useMemo(() => {
    // If Chat is closed, use normal behavior
    if (sideCarWidth === 0) return defaultTheme;

    // [THE FIX] The "Aggressive Buffer"
    // We add 1000px extra to the breakpoint requirement.
    // This effectively BANS the "Desktop Split Layout" whenever the chat is open,
    // forcing the "Mobile/Tablet Stacked Layout" which looks cleaner.
    const shiftAmount = sideCarWidth + 1000; 

    return createTheme({
      ...defaultTheme,
      breakpoints: {
        ...defaultTheme.breakpoints,
        values: {
          xs: 0,
          sm: 600 + shiftAmount,
          md: 900 + shiftAmount,
          lg: 1200 + shiftAmount, // New limit becomes ~2600px. Your screen will fail this -> Stacked View.
          xl: 1536 + shiftAmount,
        },
      },
    });
  }, [defaultTheme, sideCarWidth]);

  return (
    <ThemeProvider theme={dynamicTheme}>
      {children}
    </ThemeProvider>
  );
};